import { useFetchStatus } from '../hooks/useFetchStatus';
import { FetchStatusContext } from './context';

export const FetchStatusProvider = ({ children }) => {
  const fetchStatusHook = useFetchStatus();

  return <FetchStatusContext.Provider value={fetchStatusHook}>{children}</FetchStatusContext.Provider>;
};
